import { useState } from 'react';
import { RepoFileTree } from './RepoFileTree';
import './RepoCodeLayout.css';

export interface RepoCodeLayoutProps {
    repoPath: string;
    refName: string;
    /** 当前树路径（目录），用于文件树展开与高亮 */
    treePath: string;
    /** 当前文件路径（Blob 页），用于高亮当前文件 */
    filePath?: string;
    children: React.ReactNode;
}

export function RepoCodeLayout({ repoPath, refName, treePath, filePath, children }: RepoCodeLayoutProps) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="repo-code-layout">
            <aside className={`repo-code-layout-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
                <button
                    type="button"
                    className="repo-code-layout-toggle"
                    onClick={() => setSidebarCollapsed((c) => !c)}
                    title={sidebarCollapsed ? '展开文件树' : '折叠文件树'}
                >
                    {sidebarCollapsed ? '▶' : '◀'}
                </button>
                {!sidebarCollapsed && (
                    <RepoFileTree
                        repoPath={repoPath}
                        refName={refName}
                        treePath={treePath}
                        filePath={filePath}
                    />
                )}
            </aside>
            <div className="repo-code-layout-content">
                {children}
            </div>
        </div>
    );
}
